export const protectionTitle = `
Expert DevOps Solutions
For Your Business Growth
`;
export const protectionDescription = `
We provide professional DevOps services to help your business scale efficiently. 
Our certified team specializes in AWS, GCP, Azure, Kubernetes, Docker, Terraform, 
Ansible, and modern automation tools. Let us handle your infrastructure so you 
can focus on your core business.
`;

export const protectionImgTitle = `We Are Open For New Projects!`;
export const protectionImgDescription = `
Looking for reliable DevOps partners? We're a small but experienced team with 
AWS and GCP certifications, ready to help you build, deploy, and maintain 
scalable cloud infrastructure. Contact us to discuss your project.
`;

export const protectionSkillOneTitle = `Certified & Experienced`;
export const protectionSkillOneDescription = `
AWS and GCP certified professionals with hands-on experience in cloud infrastructure, 
containerization, and automation. We bring real-world expertise to your projects.
`;

export const protectionSkillTwoTitle = `Modern DevOps Stack`;
export const protectionSkillTwoDescription = `
Kubernetes, Docker, Terraform, Ansible, CI/CD pipelines, monitoring with Prometheus 
and Grafana. We work with the tools that power modern cloud-native applications.
`;
